/* istanbul ignore file */

export const getDealDetailsStyle = () => ({
  dealDetails: {
    width: 313,
    '& h5': {
      fontSize: 14,
    },
    '& .option-wrapper': {
      display: 'flex',
      justifyContent: 'space-between',
      fontSize: 12,
      marginBottom: 8,
      '& .option-name': {
        flex: 2,
        color: '#605E5C',
      },
      '& .option-value': {
        color: '#323130',
      },
    },
  },
});
